import type { Event } from 'models';
import { useCallback } from 'react';
import { useReminderDropdownActions } from './useReminderDropdownActions';
import { useSocialEventDropdownActions } from './useSocialEventDropdownActions';
import { useTelehealthVisitEventDropdownActions } from './useTelehealthVisitEventDropdownActions';

type P = {
  navigateToCalendar?: () => void;
  navigateToEventDetail: (id: string) => Promise<void>;
};

export const useGetEventAction = ({ navigateToCalendar, navigateToEventDetail }: P) => {
  const getTelehealthVisitActions = useTelehealthVisitEventDropdownActions();
  const { contextHolders: socialEventContextHolders, getActions: getSocialEventActions } =
    useSocialEventDropdownActions({ navigateToEventDetail });
  const { contextHolders: reminderContextHolders, getActions: getReminderActions } = useReminderDropdownActions({
    navigateToCalendar,
    navigateToEventDetail,
  });

  return useCallback(
    ({ event }: { event: Event }) => {
      switch (event.type) {
        case 'call':
        case 'clinical_review':
          return { actions: [], contextHolders: null };
        case 'reminder':
          return { actions: getReminderActions({ event }), contextHolders: reminderContextHolders };
        case 'telehealth_visit':
          return { actions: getTelehealthVisitActions({ event }), contextHolders: null };
        case 'video_conference':
        case 'webinar':
          return {
            actions: getSocialEventActions({ event }),
            contextHolders: socialEventContextHolders,
          };
      }
    },
    [
      getSocialEventActions,
      getTelehealthVisitActions,
      getReminderActions,
      reminderContextHolders,
      socialEventContextHolders,
    ],
  );
};
